export default __webpack_public_path__ + "static/media/limb_main_large.683d5a26.jpg";